import { useNavigate } from 'react-router-dom';
import { useShiftStore } from '@/stores/use-shift-store';
import { formatElapsed, formatTime12h, getOvertimeMinutes } from '@/lib/shift-helpers';

export function ShiftStatusBadge() {
  const navigate = useNavigate();
  const activeShift = useShiftStore((s) => s.activeShift);
  const clockIn = useShiftStore((s) => s.activeAttendance?.clock_in);
  const elapsedMinutes = useShiftStore((s) => s.elapsedMinutes);

  if (!activeShift) return null;

  const overtime = getOvertimeMinutes(activeShift.end_time, activeShift.start_time, clockIn, activeShift.location_id);
  const isOvertime = overtime > 0;

  return (
    <button
      type="button"
      onClick={() => navigate('/pos/shift/close')}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium transition-colors cursor-pointer ${
        isOvertime
          ? 'bg-warning-50 text-warning-700 dark:bg-warning-900/30 dark:text-warning-400 hover:bg-warning-100 dark:hover:bg-warning-900/50'
          : 'bg-success-50 text-success-700 dark:bg-success-900/30 dark:text-success-400 hover:bg-success-100 dark:hover:bg-success-900/50'
      }`}
      title={`${activeShift.name} · ${formatElapsed(elapsedMinutes)} elapsed · ends ${formatTime12h(activeShift.end_time)}`}
    >
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span className="hidden sm:inline">{activeShift.name}</span>
      <span className="text-[10px] opacity-75">
        ends {formatTime12h(activeShift.end_time)}
      </span>
      {isOvertime && (
        <span className="text-warning-600 dark:text-warning-400 font-semibold">
          +{formatElapsed(overtime)}
        </span>
      )}
    </button>
  );
}
